module.exports = __webpack_public_path__ + "static/power3-3-6aa17077d675419a6bbfd3aef248d738.png";